/*
export const someAction = (state) => {}
 */

import store from '../index'
import gql from 'graphql-tag'

export const fetchProductColours = async ({ commit, state, rootGetters }) => {
  // Abort if not logged in
  // if (!rootGetters['auth/isLoggedIn']) return
  try {
    commit('setLoaded', false)
    const result = await store.$apollo.query({
      query: gql`
        query fetchProductColours {
          productColours
        }
      `,
      deep: true
      // fetchPolicy: 'network-only'
    })
    commit('setColours', result.data.productColours.map(colour => {
      try {
        return JSON.parse(colour)
      } catch (error) {
        return undefined
      }
    }).filter(o => !!o))
    commit('setLoaded', true)
  } catch (error) {
    console.error(error)
  }
}

export const waitUntilLoaded = async ({ state, rootState }) => {
  while (true) {
    if (state.loaded) break
    if (rootState.auth.noNetworkConnection) break
    await new Promise(resolve => setTimeout(resolve, 20))
  }
}
